import request from '@/utils/request'

export default {
     //登录
    login: function (params) {
        return request.post('/system/login', params)
    },

    //退出登录
    logout: function (params) {
        return request.post('/system/logOut', params)
    },

    //修改密码
    modifyPassword: function (params) {
        return request.post('/system/modifyPassword', params)
    },

    queryLoginUserData: function (params) {
        return request.get('/system/queryLoginUserData')
    },

}


// WEBPACK FOOTER //
// ./src/api/system.js